<template>
	<body
		data-topbar="colored"
		data-layout="horizontal"
		cz-shortcut-listen="true"
	>
		<!-- Begin page -->
		<div id="layout-wrapper">
			<header id="page-topbar">
				<div class="navbar-header">
					<div class="container-fluid">
						<div class="float-right">
							<div class="dropdown d-inline-block">
								<button
									type="button"
									class="btn header-item waves-effect"
									id="page-header-user-dropdown"
									data-toggle="dropdown"
									aria-haspopup="true"
									aria-expanded="false"
								>
									<b-avatar
										data-toggle="tooltip" 
										data-placement="bottom" 
										:title="coordinadora.nombre + ' ' + coordinadora.apellido"
										variant="warning"
										:text="coordinadora.iniciales"
									></b-avatar>
									<span class="d-none ml-1"
										>{{ coordinadora.nombre }} {{ coordinadora.apellido }}</span
									>
									<i class="mdi mdi-chevron-down d-none"></i>
								</button>
								<div class="dropdown-menu dropdown-menu-right">
									<!-- item-->
									<a class="dropdown-item" href="#"
										><i
											class="mdi mdi-face-profile font-size-16 align-middle mr-1"
										></i>
										Perfil
									</a>
									<div class="dropdown-divider"></div>
									<a class="dropdown-item" href="#" @click="cerrarSesion()"
										><i
											class="mdi mdi-logout font-size-16 align-middle mr-1"
										></i>
										Cerrar Sessión</a
									>
								</div>
							</div>
						</div>
						<button
							type="button"
							class="btn btn-sm mr-2 font-size-16 d-lg-none header-item waves-effect waves-light"
							data-toggle="collapse"
							data-target="#topnav-menu-content"
						>
							<i class="fa fa-fw fa-bars"></i>
						</button>

						<div class="topnav">
							<nav class="navbar navbar-light navbar-expand-lg topnav-menu">
								<div class="collapse navbar-collapse" id="topnav-menu-content">
									<ul class="navbar-nav">
										<li class="nav-item">
											<router-link to="/index" class="nav-link">
												<i class="fas fa-home"></i> Inicio
											</router-link>
										</li>
										<li class="nav-item">
											<router-link :to='"/dashboard"' class="nav-link">
												<i class="fas fa-file-alt"></i> Dashboard
											</router-link>
										</li>
										<li class="nav-item dropdown">
											<a
												class="nav-link dropdown-toggle arrow-none"
												href="#"
												id="topnav-components"
												role="button"
												data-toggle="dropdown"
												aria-haspopup="true"
												aria-expanded="false"
											>
												<i class="fas fa-list-alt"></i> Curso
												<div class="arrow-down"></div>
											</a>
											<div
												class="dropdown-menu"
												aria-labelledby="topnav-components"
											>
												<router-link to="/biblioteca" class="dropdown-item">
													<i class="fas fa-pencil-ruler"></i
													><span> Biblioteca</span>
												</router-link>
											</div>
										</li>

										<li class="nav-item dropdown">
											<a
												class="nav-link dropdown-toggle arrow-none"
												href="#"
												id="topnav-components"
												role="button"
												data-toggle="dropdown"
												aria-haspopup="true"
												aria-expanded="false"
											>
												<i class="fas fa-users"></i> Alumnos
												<div class="arrow-down"></div>
											</a>
											<div
												class="dropdown-menu"
												aria-labelledby="topnav-components"
											>
												<router-link to="/busquedaAlumno" class="dropdown-item">
													<i class="fas fa-search"></i
													><span> Búsqueda Alumnos</span>
												</router-link>
											</div>
										</li>
                    					<!-- <li class="nav-item">
											<router-link to="/certificado" class="nav-link">
												<i class="fas fa-file-contract"></i>
                        						<span> Certificados</span>  
											</router-link>
										</li> -->
										<!-- <li class="nav-item">
                                                <a class="nav-link" href="index.html">
                                                    <i class="fas fa-file-contract"></i> Certificados
                                                </a>
                                            </li> -->
										<li class="nav-item dropdown">
											<a
												class="nav-link dropdown-toggle arrow-none"
												href="#"
												id="topnav-components"
												role="button"
												data-toggle="dropdown"
												aria-haspopup="true"
												aria-expanded="false"
											>
												<i class="fas fa-file-signature"></i> Evaluaciones
												<div class="arrow-down"></div>
											</a>
											<div
												class="dropdown-menu"
												aria-labelledby="topnav-components"
											>
												<router-link
													to="/evaluacion-curso"
													class="dropdown-item"
												>
													<i class="fas fa-search"></i
													><span> Búsqueda por curso</span>
												</router-link>
											</div>
										</li>
										<li class="nav-item">
											<router-link :to='"/historial/"+jsonCoordinadora.idAlumno' class="nav-link">
												<i class="fas fa-history"></i> Historial
											</router-link>
										</li>

										<!-- <li class="nav-item" v-if="campusSeleccionadoMulti.titulo != undefined">
											<div class="nav-link">
											   <span style="padding-right: 1.6em;padding-left: 1.6em;border-radius: 10rem;" class="badge badge-info">{{campusSeleccionadoMulti.titulo}}</span>
											   <span style="padding-right: 0.6em;padding-left: 1.6em;border-radius: 10rem;cursor:pointer;"><i class="fas fa-times" @click="deleteCampusSeleccionado()"></i></span>
											</div>
										</li> -->

										<li class="nav-item">
											<router-link :to='"/reportes"' class="nav-link">
												<i class="fas fa-file-alt"></i> Reportes
											</router-link>
										</li>

										<li class="nav-item dropdown">
											<div class="nav-link">
											   <span style="padding-right: 1.6em;padding-left: 1.6em;border-radius: 10rem;background-color: #F3931A;font-size: 13px;" class="badge badge-info" @mouseover="seleccionCampusOtherPage()" >
												   <span v-if="campusSeleccionadoMulti.titulo == undefined">&nbsp;&nbsp;Seleccionar Campus</span>
												   <span v-else>&nbsp;&nbsp;{{campusSeleccionadoMulti.titulo}}</span>
											   </span>
											   <span style="padding-right: 0.6em;padding-left: 1.6em;border-radius: 10rem;cursor:pointer;"><i class="fas fa-times" @click="deleteCampusSeleccionado()" v-show="campusSeleccionadoMulti.titulo != undefined"></i></span>
											</div>
											<div class="dropdown-menu customDropdown" aria-labelledby="topnav-components">
												<div class="containerSelector" v-for="(campus, index) in dataCampus" :key="index" style="background-color: #F3931A;font-size: 13px;">
													<span class="pointr" @click="selectCampusDropDown(campus)"> {{campus.titulo}} <span v-show="campusSeleccionadoMulti.idCampus == campus.idCampus"><i class="fas fa-check" style="color:green;"></i></span></span>
												</div>
											</div>
										</li>

									</ul>
								</div>
							</nav>
						</div>
					</div>
				</div>
			</header>

			<div class="main-content">
				<div class="page-content" style="padding:0px !important">
					<!-- Page-Title -->
					<div v-if="subMenu" class="page-title-box" style="padding: 92px 12px 65px 12px;">
						<div class="container-fluid" style="max-width: 90%;">
							<div class="row align-items-center">
								<div class="col-md-8">
									<h4 class="page-title mb-1">{{ jsonTitulo }}</h4>
									<ol class="breadcrumb m-0">
										<li
											class="breadcrumb-item active"
											v-for="(menu, index) in this.jsonMenu"
											:key="index"
										>
											<router-link :to="{ path: '/' + menu.urlTolbar }" class="text-white">
												{{ menu.nameToolbar }}
											</router-link>
										</li>
									</ol>
								</div>
							</div>
						</div>
					</div>

					<!-- end page title end breadcrumb -->
					<router-view></router-view>
				</div>
				<br />
				<br />
				<footer class="footer" style="position: static !important;">
					<div class="container-fluid">
						<div class="row">
							<div class="col-sm-12">
								<div class="text-sm-right d-none d-sm-block">
									<i class="mdi mdi-heart text-danger"></i> Vgroup
									{{ fechaActual }}
								</div>
							</div>
						</div>
					</div>
				</footer>
			</div>
		</div>
		<!-- end main content-->
	</body>
</template>
<script>
import { mapState, mapActions } from "vuex";
import router from "../../router";
import axios from "axios";

export default {
	data() {
		return {
			title: "Principal Layout",
			coordinadora: "",
			subMenu: true,
		};
	},
	computed: {
		...mapState(["accessToken"]),
		...mapState("menu", ["jsonTitulo"]),
		...mapState('curso',['titulosCurso']),
		...mapState("menu", ["jsonMenu"]),
		...mapState('campus',['dataCampus']),
		...mapState("curso",["campusSeleccionadoMulti"]),
		...mapState("alumno", ["jsonCoordinadora"]),
		...mapState('campus', ['idCampus']),

		isDashboardPage() {
		// Comprueba si la ruta actual es la página de dashboard
		return this.$route.path === '/dashboard';
		},

		fechaActual() {
			let date = new Date();
			let year = date.getFullYear();

			return year;
		}
	},
	methods: {
		...mapActions(["removeAccessToken"]),
		...mapActions('alumno',['updateJsonCoordinadora']),
		...mapActions("curso",["setCampusSeleccionadoMultiAction"]),
		...mapActions('alumno',['updateListadoAlumnosBusqueda']),
		...mapActions("curso",["filterCursosByCampusAction"]),
		...mapActions("alumno", ["updateJsonAlumno"]),
		...mapActions('curso',['updateCursoSearch']),
		...mapActions("curso", ["setCurrentSelector"]),
		...mapActions('curso',['updateGlobalLoadingMulticampus']),
		...mapActions("campus", ["addCampus"]),
		...mapActions("campus", ["setIdCampus"]),

		cerrarSesion() {
			this.removeAccessToken();
			localStorage.removeItem("listadoCampusDisponibles");
			router.push({ name: "login" });
		},

		renderizarSubMenu(param) {
			if(param == "/dashboard"){
				this.subMenu = false;
			}else{
				this.subMenu = true;
			}
		},

		async deleteCampusSeleccionado(idCampus){
			if(idCampus == undefined){
               this.setCampusSeleccionadoMultiAction([]);
			}
			let ruta = this.$route.name;
			if(ruta == "index"){
				this.filterCursosByCampusAction({
						campusSeleccionado:this.campusSeleccionadoMulti,
						titulosCurso:this.titulosCurso,
						filter:idCampus == undefined ? false : true
				});
			}else if(ruta == "historial"){
				this.updateGlobalLoadingMulticampus(true);
				let idAlumno = this.$route.params.id;
				let url = "/api/filterhistorial/" + idAlumno;
				if(idCampus != undefined){
					url = url + "/" + idCampus + "/0";
				}else{
					url = url + "/0/0";
				}
				const { data } = await this.axios.get(url);
				this.updateJsonAlumno(data);
				this.updateGlobalLoadingMulticampus(false);
			}else if(ruta == "evaluacion-curso"){
				this.updateGlobalLoadingMulticampus(true);
				let url = "api/getCursoCoordinadora";
				if(idCampus != undefined){
					url = url + "/" + idCampus;
				}
				const { data } = await this.axios.get(url);
				const { listadoCursos } = data;

				const cursos = listadoCursos.map((cursos) => ({
					...cursos,
					tituloCurso: `# ${cursos.idCurso} ${cursos.tituloCurso}`,
				}));

				this.updateCursoSearch(cursos);
				this.updateGlobalLoadingMulticampus(false);
			}else if(ruta == "busquedaAlumno"){
				this.updateGlobalLoadingMulticampus(true);
				let url = "api/getAlumnosCampus";
				if(idCampus != undefined){
					url = url + "/" + idCampus;
				}
				const { data } = await this.axios.get(url);
				const { getAlumnos: alumnosCampus } = data;
				const listadoAlumno = alumnosCampus.map((alumno) => ({
					idAlumno: alumno.idAlumno,
					nombre: alumno.numeroDocumento + " | " + alumno.nombre,
				}));

				let alHash = {};
				let listadoFinal = listadoAlumno.filter((al) =>
					alHash[al.idAlumno] ? false : (alHash[al.idAlumno] = true)
				);
				this.updateListadoAlumnosBusqueda(listadoFinal);
				this.updateGlobalLoadingMulticampus(false);
			}else if(ruta == "biblioteca"){
				this.updateGlobalLoadingMulticampus(true);
				let url = "api/getCursoCoordinadora";
				if(idCampus != undefined){
					url = url + "/" + idCampus;
				}
				const {data} = await this.axios.get(url);
				const {listadoCursos} = data;
				const cursosCoordinadora = listadoCursos.map(campus=>({
					idCurso: campus.idCurso,
					tituloCurso: `#${campus.idCurso} ${campus.tituloCurso}`
				}));
				this.updateCursoSearch(cursosCoordinadora);
				this.updateGlobalLoadingMulticampus(false);
			}
		},

		selectCampusDropDown(campus){
		   this.setCurrentSelector("disponibles");
		   this.setCampusSeleccionadoMultiAction(campus);
		   this.deleteCampusSeleccionado(campus.idCampus);
		},

		seleccionCampusOtherPage(){
			if(this.dataCampus != undefined && this.dataCampus.length == 0){
				console.log(this.dataCampus);
				//setear los que estan en el localStorage
				this.addCampus(JSON.parse(localStorage.getItem('listadoCampusDisponibles')));
				// console.log(localStorage.getItem('listadoCampusDisponibles'));
			}
		},

		/* infoCoordinadora() {
			this.axios
				.get("api/getLoginLogeado")
				.then(res => {
					this.coordinadora = res.data.usuarioDB;
					this.coordinadora["iniciales"] =
						this.coordinadora.nombre.substring(0, 1) +
						this.coordinadora.apellido.substring(0, 1);
					
					//this.updateCoordinadora(this.coordinadora);

				})
				.catch(err => {
					console.log(err);
				});
		}, */
		async infoCoordinadora() {
			const {data} = await this.axios.get("api/getLoginLogeado");
		
			const {usuarioDB:user} = data;
			const {data:dataCoordinadora} = await this.axios.get(`api/getCoordinadoraCampus`);
			
			this.coordinadora = user;
			this.coordinadora["iniciales"] =
			this.coordinadora.nombre.substring(0, 1) +
			this.coordinadora.apellido.substring(0, 1);
			this.coordinadora.privilegios = dataCoordinadora.getPrivilegios;
			
			this.updateJsonCoordinadora(this.coordinadora);
			// console.log(this.coordinadora.privilegios[0].idCampus);
			this.setIdCampus(this.coordinadora.privilegios[0].idCampus);
			//this.updateCoordinadora(this.coordinadora);
		},
		goHistorial(){
			if(this.$route.name != "historial"){
				router.push({ name: 'historial', params: { id: this.jsonCoordinadora.idAlumno } });
			}
		}
	},
	mounted() {
		this.infoCoordinadora();
		this.renderizarSubMenu(this.$route.path);
		axios.defaults.headers = { Authorization: `${this.accessToken}` };
	},
	watch: {
		$route: function(to, from) {
			this.renderizarSubMenu(to.path);
		}
	},
	
};
</script>

<style scoped>
body {
	overflow-x: auto;
}
.container-fluid {
	max-width: 90% !important;
}

.modal-mask {
	position: fixed;
	z-index: 9998;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.5);
	display: table;
	transition: opacity 0.3s ease;
}

.modal-wrapper {
	display: table-cell;
	vertical-align: middle;
}

.modal-container {
	width: 300px;
	margin: 0px auto;
	padding: 20px 30px;
	background-color: #fff;
	border-radius: 2px;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
	transition: all 0.3s ease;
	font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
	margin-top: 0;
	color: #42b983;
}

.modal-body {
	margin: 20px 0;
}

.modal-default-button {
	float: right;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
	opacity: 0;
}

.modal-leave-active {
	opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
	-webkit-transform: scale(1.1);
	transform: scale(1.1);
}
.arrow-down:after{
	visibility: hidden;
}
.badge-secondary {
    color: #fff;
    background-color: #6c757d;
}
.badge {
    padding: 1.10em 1.4em;
}
.pointr{
	cursor: pointer;
}
.containerSelector{
	font-size: 14.7px;
    position: relative;
    padding: 15px;
}
.customDropdown{
	color: #fff;
    background-color: #17a2b8 !important;
	border: none !important;
}

@media (min-width: 1500px) {
	.d-xxl-inline-block {
		display: inline-block !important;
	}
}
</style>
